import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const getKycDocumentCategoriesLov = ( reqBody:any,tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.getKycDocumentCategories,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: reqBody,
  }
  return executeRequest(request)
    .then((data) => {
      return responseParser(data.data)
    })
    .catch((error) => {
      throw error
    })
}

export { getKycDocumentCategoriesLov }
